import React from "react";
import { useDrag } from "react-dnd";

// Utils
import items from "../../utils/items";
import RealtimeConnection from "../../utils/RealtimeConnection";

export default function MainDraggableToken({ canEdit, value, tokenType }) {
  const [, drag] = useDrag({
    item: {
      type: items.token[tokenType],
      value,
    },
    end: (item, monitor) => {
      if (monitor.didDrop()) {
        const droppedItem = monitor.getDropResult();
        if (droppedItem !== null && droppedItem.success) {
          const obj = {
            type:
              tokenType === 5
                ? "token5"
                : tokenType === 10
                ? "token10"
                : "blacktoken",
            value,
          };

          RealtimeConnection.decreaseTeamTable(obj);
        }
      }
    },
  });

  const canDrag = canEdit ? drag : null;

  const isBlackToken = tokenType === "blacktoken";

  const displayText =
    tokenType === 5 || tokenType === 10
      ? `Credit ${tokenType}%`
      : "Venture Capital";

  return (
    <div className="tokenDraggable" ref={canDrag}>
      <div
        className={`Token-container-draggable ${
          isBlackToken ? "black-token" : ""
        }`}
      >
        <div className="Token-value">{value}</div>
        <div className="Token-text">{displayText}</div>
      </div>
    </div>
  );
}
